// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__15jbN","icon":"SortAdornment_icon__31McY","up":"SortAdornment_up__3dGaI","down":"SortAdornment_down__2o3tM","active":"SortAdornment_active__3rBWM"};